import React from "react";
import { downloadFromBlob } from "src/ui/utils/download";

import {
    announcementEmailListTypes,
    exportAnnouncementEmails,
    ExportAnnouncementEmailsPayload,
} from "@admin/api/announcementsExport";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useExportAnnouncementEmails = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const onExport = async (payload?: ExportAnnouncementEmailsPayload): Promise<boolean> => {
        setIsLoading(true);
        try {
            const { blob, fileName } = await exportAnnouncementEmails(payload);
            downloadFromBlob(blob, fileName);
            return true;
        } catch (error) {
            const err = error as Error;
            showErrorToast(err.message);
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        onExportSubscribers: () => onExport({ listType: announcementEmailListTypes.newsletterSubscribers }),
        onExportCustomers: () => onExport(),
    };
};
